import Base from './base'
import Request from '@utils/request'

class Auth extends Base {
  async login({ username, password }) {
    const res = await Request.post('/api/auth/login', { username, password })
    return res
  }

  async logout() {
    const res = await Request.post('/api/auth/logout')
    return res
  }

  async forgotPassword({ email }) {
    const res = await Request.post('/api/auth/forgot-password', { email })
    return res
  }

  async resetPassword(payload) {
    const res = await Request.put('/api/auth/reset-password', payload)
    return res
  }
}

export default new Auth()
